import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { INQUIRY_TYPES } from '@/pages/inquiry/lib/types';
import { InquiryPage } from '@/pages/inquiry/ui/InquiryPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

const inquirySearchSchema = z.object({
  /** 種別事前選択（既存4導線からの誘導用） */
  type: z.enum(INQUIRY_TYPES).optional(),
});

const InquiryRouteComponent = () => {
  const { type } = Route.useSearch();
  return <InquiryPage initialType={type} />;
};

export const Route = createFileRoute('/_protected/inquiry/')({
  beforeLoad: () => {
    requireReleaseFlag('system_feedback');
  },
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: inquirySearchSchema,
    }),
  component: InquiryRouteComponent,
});
